module.exports = __webpack_public_path__ + "img/level_0_img_1.0bdb25d2.jpeg";